import { render, staticRenderFns } from "./BCorpText.vue?vue&type=template&id=38ecdc91&"
import script from "./BCorpText.vue?vue&type=script&lang=ts&"
export * from "./BCorpText.vue?vue&type=script&lang=ts&"
import style0 from "./BCorpText.vue?vue&type=style&index=0&id=38ecdc91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports